
import React, { Fragment } from 'react';
import { ConditionalRendering } from '@components/common/conditional-rendering';

const Textarea = props => {
    const {
        inputData: { cols, disabled, id, isInputRequired, helperClasses, name, placeholder, rows, type, value, maxLength, spellCheck = false },
        inputActions: { handleFieldChange, handleFieldBlur },
        label: { text, labelClasses, isLabelVisible = true, ariaLabel },
        labelIcon = {},
    } = props;

    const handleValueChange = e => {
        handleFieldChange(e.target.value);
    };

    const handleValueBlur = e => {
        handleFieldBlur(e.target.value);
    };

    return (
        <Fragment>
            <div className={`grid-row gi-component gi-${type} ${helperClasses && helperClasses.join(' ')}`}>
                <ConditionalRendering isTrue={isLabelVisible}>
                    <label
                        htmlFor={id}
                        className={`tablet:grid-col-4 gi-${type}__label ${
                            labelClasses && labelClasses.join(' ')
                        } iconed-${!!labelIcon.icon} required-${isInputRequired}`}
                        aria-label={ariaLabel}
                    >
                        {text}
                        {labelIcon.icon ? labelIcon.icon : null}
                    </label>
                </ConditionalRendering>
                <textarea
                    aria-required={isInputRequired}
                    className={`tablet:grid-col-6 gi-${type}__input`}
                    data-testid={id}
                    cols={cols}
                    disabled={disabled}
                    id={id}
                    name={name}
                    placeholder={placeholder}
                    onBlur={handleValueBlur}
                    onChange={handleValueChange}
                    onFocus={props.inputActions.onFieldFocus}
                    rows={rows}
                    value={value || ''}
                    maxLength={maxLength}
                    spellCheck={spellCheck}
                />
            </div>
        </Fragment>
    );
};

export default Textarea;
